export default {
  /** 文本输入组件 1 */
  TEXTINPUT: 1,
  /** 单选组件 2 */
  SINGLESELECT: 2,
  /** 单选组件 3 */
  RADIOGROUP: 3,
  /** 数字输入组件 4 */
  NUMBERINPUT: 4,
  /** 单个日期选择组件 8 */
  DATEPICKER: 8,
  /** 多选组件 16 */
  MULTIPLESELECT: 16,
  /** 文本域输入组件 32 */
  TEXTAREA: 32,
  /** 多文件上传列表组件 64 */
  UPLOADFILES: 64,
  /** 日期范围选择组件 128 */
  DATEPICKERRANGE: 128,
  /** 区间价格组件 256 */
  AREAPRICE: 256,
  /** 实例室单独计价组件 512 */
  CAPABILITYLABPRICE: 512,
  /** 级联组件 1024 */
  CASCADER: 1024,
  /** 富文本 2048 */
  UTEDITOR: 2048,
  /** 基础能力选择器 4096 */
  CAPABILITYSELECTOR: 4096,
  /** 基础能力选择器 8192 */
  ADDITIONALSERVICESELECTOR: 8192,
  /** 服务属性配置器 16384 */
  SCHEMEATTRIBUTE: 16384,
  /** 表格选择器 32768 */
  TABLESELECTOR: 32768,
  /** 服务价格配置器 65535 */
  SCHEMEATTRIBUTEPRICE: 65535,
  /** 文本展示组件 65536 */
  TEXT: 65536,
};
